import React, { useState } from 'react';
import { Box, Typography, Button, Card, CardContent, Chip, LinearProgress, Snackbar, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { mockProjects } from '../data/mockData';
import CreateProjectModal from '../components/projects/CreateProjectModal';

const Projects: React.FC = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  
  // Filtrar proyectos del usuario actual (simulado)
  const userProjects = mockProjects;

  const getStageColor = (stage: string) => {
    switch (stage) {
      case 'Idea':
        return 'info';
      case 'Validación':
        return 'warning';
      case 'Crecimiento Temprano':
        return 'success';
      case 'Escalamiento':
        return 'error';
      default:
        return 'default';
    }
  };

  const handleCreateProject = (project: any) => {
    console.log('Nuevo proyecto creado:', project);
    setSnackbar({ 
      open: true, 
      message: `Proyecto "${project.name}" creado exitosamente` 
    });
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">Mis Proyectos</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpenModal(true)}
        >
          Nuevo Proyecto
        </Button>
      </Box>

      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: 3 }}>
        {userProjects.map(project => {
          const progress = 0; // Calcular basado en milestones cuando estén disponibles
          
          return (
            <Card key={project.id} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 2 }}>
                  <Typography variant="h6" component="div">
                    {project.name}
                  </Typography>
                  <Chip 
                    label={project.stage} 
                    size="small" 
                    color={getStageColor(project.stage) as any}
                  />
                </Box>
                
                <Typography variant="body2" color="text.secondary" paragraph>
                  {project.description}
                </Typography>

                <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                  Industria: {project.industry}
                </Typography>
                
                <Box sx={{ mt: 2 }}>
                  <Typography variant="caption" color="text.secondary">
                    Progreso: {progress}%
                  </Typography>
                  <LinearProgress variant="determinate" value={progress} sx={{ mt: 1 }} />
                </Box>
              </CardContent>
              <Box sx={{ p: 2, pt: 0 }}>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={() => navigate(`/proyectos/${project.id}`)}
                >
                  Ver Detalles
                </Button>
              </Box>
            </Card>
          );
        })}
      </Box>

      {userProjects.length === 0 && (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No tienes proyectos aún
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Crea tu primer proyecto para comenzar
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setOpenModal(true)}
          >
            Crear Primer Proyecto
          </Button>
        </Box>
      )}

      <CreateProjectModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSubmit={handleCreateProject}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity="success" onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Projects;
